<template>
  <div>
    <span
      v-if="!showAsTotal && showModifier"
      :class="siteIdentityClass('option-cost__modifier')"
    >+</span>
    <span :class="siteIdentityClass('option-cost__lead-in-string')">{{ costString }}</span>
    <span
      v-if="isPerFrame"
      class="visible-lg-inline"
    > / @BrandInvariant.Image.ToLower()</span>
  </div>
</template>

<script>
import currencyFormatter from '@/shared/lib/currency-formatter'

export default {
  name: 'OptionCost',
  props: {
    cost: { type: Number, default: null, required: true },
    packageBaseCost: { type: Number, default: null, required: true },
    showAsTotal: { type: Boolean, default: false, required: false },
    isPerFrame: { type: Boolean, default: false, required: false },
    showModifier: { type: Boolean, default: true, required: false }
  },
  computed: {
    costString () {
      if (this.cost === 0 && this.isLetterJacket) {
        return 'Included'
      }

      if (this.showAsTotal) {
        const total = this.packageBaseCost + this.cost
        return currencyFormatter.format(total, this.currentCultureNumberFormat, this.currency)
      } else {
        return currencyFormatter.format(this.cost, this.currentCultureNumberFormat, this.currency)
      }
    },
    currentCultureNumberFormat () {
      return this.$store.state.catalogPageCommon.currentCultureNumberFormat
    },
    currency () {
      return this.$store.state.catalogPageCommon.currency
    }
  }
}
</script>

<style lang="scss" scoped>
  .option-cost {
    &__modifier {
      font-weight: bold;
      position: relative;
      top: 0; // Default style

      @media (max-width: 768px) {
        top: -10px;
      }
      // GradImages-specific override
      &--grad-images {
        top: -23px;

        @media (max-width: 768px) {
          top: -10px;
        }
      }
      // LetterJacket-specific override
      &--letter-jacket {
        font-weight: normal;
      }
    }

    &__lead-in-string {
      font-weight: bold;
      margin-right: 0; // Default style
      position: relative;
      top: 0;

      @media (max-width: 768px) {
        top: -10px;
        margin-right: 0;
      }
      // GradImages-specific override
      &--grad-images {
        margin-right: -200px;
        top: -23px;

        @media (max-width: 768px) {
          top: -10px;
          margin-right: 0;
        }
      }
      // LetterJacket-specific override
      &--letter-jacket {
        font-weight: normal;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/PackageOption/OptionCost.vue